import React, { useState, useEffect, useRef } from "react";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  Grid,
  IconButton,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { tokens } from "../../theme";
import ModalCharge from "../../modal/modalCharge";
import ModalCamion from "../../modal/camiones/modalCamion";
import Header from "../../components/Header";
import ModalImage from "../../modal/imagen/modalImagen";
import { PostDatos, PostDatosDevolucion, getOneTicket } from "../../services/stockDeposito.services";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getOneProductoDepositoView } from "../../services/amoxarifado.services";
import ModalPatrimonio from "../../modal/amoxarifado/modalPatrimonio";
import ModalSector from "../../modal/amoxarifado/modalSector";
import ModalUserData from "../../modal/user/modalUserData";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import secureStorage from "../../utils/secureStorage";

const StockDeposito = () => {
  const [proveedor, setProveedor] = useState("");
  const [serviceType, setServiceType] = useState(1);
  const [products, setProducts] = useState([]);
  const [modalPatrimonio, setModalPatrimonio] = useState(false);
  const [modalSector, setModalSector] = useState(false);
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [modalUserOpen, setModalUserOpen] = useState(false);
  const initialRows = [
    {
      id: 1,
      producto: { cod: "", descripcion: "", cantidad: "" },
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cantidad, setCantidad] = useState(0); // Estado para guardar la información de la impresora
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [modalCamionOpen, setModalCamionOpen] = useState(false);
  const USER = secureStorage.getItem("id");
  const formikRef = useRef(null);
  const [sinNota, setSinNota] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null); // Estado para la imagen seleccionada
  const initialValues = {
    operacion: "Devolucion",
    numeroNota: "",
    modelo: "",
    operacion: "",
    formaDePago: "",
    condicionPago: "",
    id_vehiculo: "",
    id_producto: "",
    operacion: "",
    cantidad: "",
    descripcion: "",
    cod: "",
    cantidad2: "",
    descripcion: "",
    id_patrimonio: "",
    usuario_re: "",
    ticket: "",
    sinNota: false, // <- si lo usás
  };

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    let numeroNotaFinal = values.numeroNota;
    let descripcionFinal = values.descripcion;


       let isValid = true;
    let errorMessage = "";

for (let i = 0; i < products.length; i++) {
  const producto = products[i];
  const cantidad = parseInt(producto.cantidad, 10);
  const cantidadPrestada = parseInt(producto.cantidad_prestada, 10) || 0;
  const cantidadDevuelta = parseInt(producto.cantidad_devuelta, 10) || 0;

  if (isNaN(cantidad) || cantidad <= 0) {
    isValid = false;
    errorMessage = `La cantidad del producto "${producto.producto}" es inválida o está vacía.`;
    break;
  }

  const cantidadMaxima = cantidadPrestada - cantidadDevuelta;

  if (cantidad > cantidadMaxima) {
    isValid = false;
    errorMessage = `Solo puede devolver hasta ${cantidadMaxima} unidades del producto "${producto.producto}".`;
    break;
  }
}


    if (!isValid) {
      console.error("❌ Error en validación:", errorMessage);
      setRegistrationError(true);
      setError(errorMessage);
      setIsLoading(false);
      return;
    }

    const valuesToSend = {
      data: products.map((product) => ({
        id_producto: product.id_producto || "",
        operacion: "Devolucion",
        cod: product.id || "",
        deposito: product.id_deposito || "",
        estante: product.id_estante || "",
        fila: product.id_fila || "",
        columna: product.id_columna || "",
        obs: descripcionFinal,
        cantidad:
          values.operacion === "Devolucion"
            ? -Math.abs(parseInt(product.cantidad) || 0)
            : parseInt(product.cantidad) || 0,
        id_usuario: parseInt(USER),
        id_nota: numeroNotaFinal || "",
        id_patrimonio: product.id_patrimonio,
        usuario_re: product.id_usuario_re,
        id_prestamo: product.id || 0,
        estado_devolucion: 1,
      })),
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const response = await PostDatosDevolucion(valuesToSend);

      setRegistrationSuccess(true);
      resetForm();
      setProducts([]);
    } catch (error) {
      console.error("Error al enviar los datos", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  useEffect(() => {
    setServiceType(proveedor);
  }, [proveedor]);

  const handleSelectCamion = (Camion, setFieldValue) => {
    setFieldValue("id_vehiculo", Camion.id);
    setModalCamionOpen(false); // Cerrar el modal de productos
  };

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];

    if (field === "producto.serie") {
      updatedProducts[index].producto = {
        ...updatedProducts[index].producto,
        serie: value,
      };
    } else {
      updatedProducts[index][field] = value;
    }

    setProducts(updatedProducts);
    actualizarCantidadTotal(updatedProducts);
  };

const handleTicketEnter = async (values) => {
  if (!values.ticket) return;

  try {
    const productosDelTicket = await getOneTicket(values.ticket);

    const productosTransformados = productosDelTicket.map((p) => ({
      ...p,
        cantidad_prestada: Math.abs(Number(p.cantidad)) || 1,  // prestada original
        cantidad: Math.abs(Number(p.cantidad)) - p.cantidad_devuelta || 1, // siempre positivo, mínimo 1 si viene NaN
    }));

    setProducts(productosTransformados);
    toast.success("Productos cargados desde el ticket");
  } catch (error) {
    setProducts([]);
    console.error("Error al obtener productos del ticket:", error);
    toast.error("No se encontraron productos para este ticket");
  }
};

  // Eliminar un producto
  const removeProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
    actualizarCantidadTotal(updatedProducts);
  };

  const actualizarCantidadTotal = (productos) => {
    const total = productos.reduce((sum, prod) => {
      const cantidad = parseFloat(prod.cantidad);
      return sum + (isNaN(cantidad) ? 0 : cantidad);
    }, 0);
    setCantidad(total);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <Box sx={{ padding: "20px", height: "80vh", overflowY: "auto" }}>
      <Header title="Stock Deposito" subtitle="Disponibilidad Stock" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        initialValues={initialValues}
        validationSchema={checkoutSchema}
        onSubmit={handleFormSubmit}
        innerRef={formikRef} // Utilizamos ref para evitar ciclo de actualización
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                "& .MuiOutlinedInput-root": {
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiOutlinedInput-root.MuiOutlinedInput-notchedOutline": {
                  border: "none",
                  background: `${colors.primary[950]} !important`,
                  borderBottom: `1px solid ${colors.grey[100]} !important`,
                },
                "& .MuiInputBase-input": {
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiInputLabel-root": {
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiSvgIcon-root": {
                  color: `${colors.grey[100]} !important`,
                  zIndex: 10,
                },
                "& .MuiInputLabel-root": {
                  zIndex: 200,
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: "12px",
                  zIndex: 100,
                },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                label="Operacion"
                name="operacion"
                value={values.operacion || "Devolucion"}
                onChange={(e) => {
                  handleChange(e);
                  setSinNota(false); // Resetear switch si cambia la operación
                }}
                error={!!touched.operacion && !!errors.operacion}
                helperText={touched.operacion && errors.operacion}
                disabled={true} // Deshabilitado para evitar cambios manuales
              >
              </TextField>

              <TextField
  fullWidth
  variant="filled"
  label="ticket"
  name="ticket"
  value={values.ticket}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleTicketEnter(values); // Se ejecuta al presionar Enter
    }
  }}
  onChange={(e) => {
    handleChange(e);
    setSinNota(false);
  }}
  error={!!touched.ticket && !!errors.ticket}
  helperText={touched.ticket && errors.ticket}
              >
              </TextField>
                <>
                  <Box mb={2}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={sinNota}
                          onChange={() => setSinNota((prev) => !prev)}
                          color="primary"
                        />
                      }
                      label="Diferencia en Entrega"
                    />
                  </Box>

                  {/* Si se marcó el switch, mostrar campo de descripción */}
                  {sinNota && (
                    <Box mb={2}>
                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Observación"
                        name="descripcion"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.descripcion}
                        error={!!touched.descripcion && !!errors.descripcion}
                        helperText={touched.descripcion && errors.descripcion}
                      />
                    </Box>
                  )}
                </>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              mb={2}
              sx={{ marginTop: "3vw" }}
            >
              <Typography variant="body1">Productos</Typography>
            </Box>

            {products.map((product, productIndex) => (
              <Box
                key={productIndex}
                mt={2}
                sx={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "8px",
                  paddingLeft: "10vh",
                }}
              >
                {/* Producto y Cantidad */}
                <Grid container spacing={4} alignItems="center">

                   <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Producto"
                      value={product.producto || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.producto",
                          e.target.value
                        )
                      }
                    />
                  </Grid>

                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Cantidad"
                      value={product.cantidad}
                      onChange={(e) => {
                        const valorPositivo = Math.abs(Number(e.target.value)) || "";
                        handleProductChange(productIndex, "cantidad", valorPositivo);
                      }}
                      disabled={!sinNota}
                    />

                  </Grid>

                 
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Prestatario"
                      value={product.usuario_re || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.usuario_re",
                          e.target.value
                        )
                      }
                    />
                  </Grid>

                  {product.imagen && (
                    <Grid item xs={10}>
                      <img
                        src={`${getApiImagen()}${product.imagen}`}
                        alt="Producto"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          marginTop: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleImageClick(
                            `${getApiImagen()}${product.imagen}`
                          )
                        }
                      />
                    </Grid>
                  )}

                  <Grid item xs={1}>
                    <IconButton
                      color="secondary"
                      onClick={() => removeProduct(productIndex)}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            ))}

            <Box
              sx={{ paddingRight: "2%", paddingTop: "3%", paddingBottom: "3%" }}
              className="wrap"
            >
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  border: "none",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  cursor: "pointer",
                  marginRight: "1vw",

                  "&:hover": { backgroundColor: "#bac609" },
                }}
              >
                Registrar
              </Button>
            </Box>

            <ModalCharge isLoading={isLoading} />
            <ModalCamion
              open={modalCamionOpen} // Estado del modal de Camions
              onClose={() => setModalCamionOpen(false)} // Cerrar el modal de Camions
              onSelectVehiculos={(Camion) =>
                handleSelectCamion(Camion, setFieldValue)
              } // Lógica para seleccionar productos
            />
            <ModalImage
              open={Boolean(selectedImage)}
              onClose={handleCloseImageModal}
              imageSrc={selectedImage}
            />

            <ModalPatrimonio
              open={modalPatrimonio}
              onClose={() => setModalPatrimonio(false)}
              // idCategoria={idCategoriaActual}
              // nombreCategoria={categoriaSeleccionada?.categoria}
              onSelectPatrimonio={(patrimonio) => {
                // setSubcategoriaSeleccionada(subcategoria);
                setFieldValue("id_patrimonio", patrimonio.id);
                setModalPatrimonio(false);
              }}
              sector={sectorSeleccionado}
            />

            <ModalSector
              open={modalSector}
              onClose={() => setModalSector(false)}
              // idCategoria={idCategoriaActual}
              // nombreCategoria={categoriaSeleccionada?.categoria}
              onSelectSector={(sector) => {
                setSectorSeleccionado(sector);
                // setSubcategoriaSeleccionada(subcategoria);
                // setFieldValue("id_patrimonio", patrimonio.id);
                setModalSector(false);
                setModalPatrimonio(true);
              }}
            />

            <ModalUserData
              open={modalUserOpen}
              onClose={() => setModalUserOpen(false)}
              // idCategoria={idCategoriaActual}
              // nombreCategoria={categoriaSeleccionada?.categoria}
              onSelectUsuario={(user) => {
                // setSubcategoriaSeleccionada(subcategoria);
                setFieldValue("usuario_re", user.id);
                setModalUserOpen(false);
              }}
            />
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  descripcion: yup.string().when("sinNota", {
    is: true,
    then: (schema) => schema.required("Ingrese una descripción"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
export default StockDeposito;
